var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIssuers({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3565_22465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 17.4999H18.3333V10.8333H16.6667V17.4999H13.3333V10.8333H11.6667V17.4999H8.33333V10.8333H6.66667V17.4999H3.33333V10.8333H1.66667V17.4999H0.833333C0.373333 17.4999 0 17.8724 0 18.3333C0 18.7941 0.373333 19.1666 0.833333 19.1666H19.1667C19.6267 19.1666 20 18.7941 20 18.3333C20 17.8724 19.6267 17.4999 19.1667 17.4999Z",
    fill: "#9CA2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5658 5.10174L10.3992 0.101738C10.15 -0.0332617 9.85 -0.0332617 9.60083 0.101738L0.434167 5.10174C0.166667 5.24757 0 5.5284 0 5.8334V8.3334C0 8.79424 0.373333 9.16674 0.833333 9.16674H19.1667C19.6267 9.16674 20 8.79424 20 8.3334V5.8334C20 5.5284 19.8333 5.24757 19.5658 5.10174ZM10 6.66674C9.07917 6.66674 8.33333 5.9209 8.33333 5.00007C8.33333 4.07924 9.07917 3.33341 10 3.33341C10.9208 3.33341 11.6667 4.07924 11.6667 5.00007C11.6667 5.9209 10.9208 6.66674 10 6.66674Z",
    fill: "#4E5459"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3565_22465"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIssuers);
export default __webpack_public_path__ + "static/media/issuers.82c4c0cbad3d874824e76e48332ca7fc.svg";
export { ForwardRef as ReactComponent };